import { Link } from 'react-router-dom';

export default function ArticlePreviewSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-3">
            Latest Guide
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            Explore Our Spreadsheet Guides
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            In-depth articles covering everything you need to know about spreadsheet shopping — from beginner tips to advanced strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-5xl mx-auto">
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="group block p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
          >
            <div className="w-full h-40 rounded-md overflow-hidden mb-4">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20with%20open%20notebook%20showing%20colorful%20organized%20product%20categories%20and%20charts%2C%20small%20potted%20plant%2C%20coffee%20cup%2C%20soft%20morning%20sunlight%20through%20window%2C%20warm%20cream%20and%20sand%20tones%2C%20editorial%20lifestyle%20photography%2C%20clean%20aesthetic%2C%20professional%20organized%20workspace&width=800&height=500&seq=article-card-04-guide&orientation=landscape"
                alt="Hipobuy Spreadsheet Complete Guide"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex items-center gap-2 mb-2">
              <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold">
                Guide
              </span>
              <span className="text-xs text-foreground-400">15 min read</span>
            </div>
            <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
              Complete Hipobuy Spreadsheet Guide 2026
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Everything you need to know about using spreadsheet-based shopping guides — from product discovery to smart buying strategies.
            </p>
          </Link>

          <Link
            to="/spreadsheet-platform-comparison"
            className="group block p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all cursor-pointer"
          >
            <div className="w-full h-40 rounded-md overflow-hidden mb-4">
              <img
                src="https://readdy.ai/api/search-image?query=Two%20smartphones%20side%20by%20side%20on%20a%20white%20desk%20displaying%20comparison%20charts%20and%20product%20images%2C%20minimalist%20tech%20lifestyle%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20background%2C%20clean%20editorial%20composition%2C%20professional%20modern%20workspace%20with%20greenery%20accent&width=800&height=500&seq=article-card-05-compare&orientation=landscape"
                alt="Spreadsheet Platform Comparison"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex items-center gap-2 mb-2">
              <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold">
                Comparison
              </span>
              <span className="text-xs text-foreground-400">14 min read</span>
            </div>
            <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors">
              Spreadsheet Platform Comparison 2026
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              In-depth comparison of Hipobuy, Kakobuy, CSSBuy, Superbuy, and Oopbuy — find which spreadsheet platform fits your shopping style.
            </p>
          </Link>

          <Link
            to="/hipobuy-spreadsheet-safety"
            className="group block p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-secondary-300 transition-all cursor-pointer"
          >
            <div className="w-full h-40 rounded-md overflow-hidden mb-4">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20white%20desk%20with%20open%20notebook%20showing%20checklist%20and%20verified%20badges%2C%20magnifying%20glass%20examining%20product%20details%2C%20soft%20natural%20morning%20light%2C%20warm%20cream%20tones%2C%20minimalist%20editorial%20photography%2C%20trustworthy%20professional%20aesthetic%2C%20organized%20research%20concept&width=800&height=500&seq=article-card-06-safety&orientation=landscape"
                alt="Shopping Safety Guide"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex items-center gap-2 mb-2">
              <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold">
                Safety
              </span>
              <span className="text-xs text-foreground-400">11 min read</span>
            </div>
            <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-secondary-600 transition-colors">
              Spreadsheet Shopping Safety Guide
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Essential safety practices, verification methods, and red flags to protect yourself while using spreadsheet-based shopping guides.
            </p>
          </Link>
        </div>
      </div>
    </section>
  );
}